import { useState } from "react"
import { useNavigate } from "react-router"
import { fetchUserWallets } from "../../settings/wallets/refill/refillApi"
import { SelectWalletDialog } from "../../settings/wallets/refill/components/SelectWalletDialog"
import { MakePurchaseDialog } from "../../settings/wallets/refill/components/MakePurchaseDialog"
import { UserWalletsRefillState } from "../../settings/wallets/refill/pages/UserWalletsRefill"
import { UserWallet } from "../../settings/wallets/refill/refillTypes"
import { useOrderDialogUrlState } from "../../../../../shared/components/createOrder/hooks/useOrderDialogUrlState"
import { getUserDetails, UserQuery } from "../../../../users/userApi"
import { CreateOrderType } from "../../../../../shared/components/createOrder/helpers"
import { selectUserId } from "../../../../login/loginSelectors"
import { useAppSelector } from "../../../../store/storeHooks"
import {
    TopBarNewButtonMenu,
    UserActionsMenuItemConfig,
} from "../../../../../shared/components/topBarNewButtonMenu/TopBarNewButtonMenu"
import { useApiMutation } from "../../../../../core/api/useApiMutation"
import { getRefillWalletRoute } from "../../../../../constants/routes"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { moduleItemFactories } from "./moduleItemFactories"

export function UserCreateNewButton() {
    const userId = useAppSelector(selectUserId)
    const { openDialog } = useOrderDialogUrlState()
    const navigate = useNavigate()

    const [openSelectWalletDialog, setOpenSelectWalletDialog] = useState(false)
    const [openMakePurchaseDialog, setOpenMakePurchaseDialog] = useState(false)
    const [userWallets, setUserWallets] = useState<Array<UserWallet> | null>(null)

    const { mutateAsync } = useApiMutation(fetchUserWallets, {
        async onSuccess(_, data) {
            setUserWallets(data.wallets)
        },
    })

    const { data: userDetails } = useApiQuery(getUserDetails, {
        queryName: UserQuery.USER_DETAILS,
        dependencies: {
            userId: userId ?? 0,
        },
    })

    const handleCreateOrder = (type: CreateOrderType) => {
        openDialog({
            activeOrderTab: type,
        })
    }

    const handleRefillWallet = async () => {
        const response = await mutateAsync({ userId: userId ?? 0 })

        if (response.wallets?.length === 1) {
            const state: UserWalletsRefillState = {
                wallet: response.wallets[0],
            }
            navigate(getRefillWalletRoute(response.wallets[0].acquirer.acquirerSetupId, response.wallets[0]?.id), {
                state,
            })
        } else {
            setOpenSelectWalletDialog(true)
        }
    }

    const handleOpenMakePurchase = () => {
        setOpenMakePurchaseDialog(true)
    }

    const activeModules = new Set(userDetails?.user?.modules?.filter((m) => m.isActive)?.map((m) => m.name))

    const items: UserActionsMenuItemConfig[] = moduleItemFactories({
        handleCreateOrder,
        handleOpenMakePurchase,
        handleRefillWallet,
    })
        .filter((factory) => activeModules.has(factory.moduleName))
        .map((factory) => factory.create())

    return (
        <>
            <TopBarNewButtonMenu items={items} />

            {/*hide it for now*/}
            {/* {false && (
                <>
                    {activeModules.size > 1 && (
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <MenuItem className={classes.menuItem} onClick={handleMenuClose}>
                            <Box className={cx(classes.iconBox, classes.iconSlate)}>
                                <FontAwesomeIcon icon={faShieldKeyhole} />
                            </Box>
                            <Box>
                                <LocalizedStrict id="user-create-new-menu-order-for-another-user-title">
                                    <Typography variant="subtitle1">Order on behalf of another user</Typography>
                                </LocalizedStrict>
                                <LocalizedStrict id="user-create-new-menu-order-for-another-user-subtitle">
                                    <Typography variant="body2" color="textSecondary">
                                        Create a resource booking or meeting service order on behalf of another user
                                    </Typography>
                                </LocalizedStrict>
                            </Box>
                        </MenuItem>
                    </Grid>
                </>
            )} */}

            {openSelectWalletDialog && (
                <SelectWalletDialog
                    open={openSelectWalletDialog}
                    onClose={() => setOpenSelectWalletDialog(false)}
                    onSelect={(wallet) => {
                        setOpenSelectWalletDialog(false)
                        const state: UserWalletsRefillState = {
                            wallet,
                        }
                        navigate(getRefillWalletRoute(wallet.acquirer.acquirerSetupId, wallet.id), { state })
                    }}
                    userWallets={userWallets}
                />
            )}

            {openMakePurchaseDialog && (
                <MakePurchaseDialog open={openMakePurchaseDialog} onClose={() => setOpenMakePurchaseDialog(false)} />
            )}
        </>
    )
}
